import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { i18n } from './i18n'
import { initAssistancePortalConfig } from './config/assistancePortalConfig'
import { useAuthStore, isAuthCallbackPending } from './stores/useAuthStore'
import './styles.css'

async function bootstrap() {
  initAssistancePortalConfig()
  var app = createApp(App)
  var pinia = createPinia()
  app.use(pinia)
  var authStore = useAuthStore()
  if (!isAuthCallbackPending()) {
    await authStore.init()
  }
  app.use(router)
  app.use(i18n)
  await router.isReady()
  app.mount('#app')
}

bootstrap()
